import InvoiceListResponse from "../models/serviceApi/InvoiceListResponse";
import InvoiceList from "../models/domain/InvoiceList";
import InvoiceMapper from "./InvoiceMapper";

export default class InvoiceListMapper {
  static mapResponseToModel(response: InvoiceListResponse): InvoiceList {
    return new InvoiceList(
      response.invoices?.map(InvoiceMapper.mapResponseToModel) ?? [],
      response.status,
    );
  }
}
